import { render, staticRenderFns } from "./SerchAttractions.vue?vue&type=template&id=5d2c47fa&scoped=true"
import script from "./SerchAttractions.vue?vue&type=script&lang=js"
export * from "./SerchAttractions.vue?vue&type=script&lang=js"
import style0 from "./SerchAttractions.vue?vue&type=style&index=0&id=5d2c47fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c47fa",
  null
  
)

export default component.exports